import { $api } from "@/lib/api-client";

export const useStatementEligibility = (enabled: boolean) =>
  $api.useQuery("get", "/statements/eligibility", {}, { enabled });
